import React from 'react';
import classnames from 'classnames';
import { string, oneOfType, node, bool } from 'prop-types';
import styles from './RadioButton.scss';
import { withFocusable } from 'wix-style-react/dist/src/common/Focusable';

class RadioButton extends React.PureComponent {
  render() {
    const {
      children,
      className,
      dataHook,
      focusableOnFocus,
      focusableOnBlur,
      focusableIsFocused,
      focusableIsFocusVisible,
      button,
      ...passThrough
    } = this.props;

    return (
      <label
        className={classnames([
          styles.label,
          className,
          focusableIsFocused && focusableIsFocusVisible && styles.focused,
          button && styles.button,
        ])}
        data-hook={dataHook}
      >
        <input
          onBlur={focusableOnBlur}
          onFocus={focusableOnFocus}
          type="radio"
          {...passThrough}
          className={styles.radio}
        />
        {!button && (
          <div className={styles.customRadio}>
            <div className={styles.customRadioInner} />
          </div>
        )}
        <span className={styles.text}>{children}</span>
      </label>
    );
  }
}

RadioButton.displayName = 'RadioButton';

RadioButton.propTypes = {
  className: string,
  children: oneOfType([string, node]),
  name: string,
  dataHook: string,
  button: bool,
};

export default withFocusable(RadioButton);
